export default "__VITE_ASSET__DqIEosUx__"